<template>
  <router-view />
</template>
<script>

const popups = {}
const attendances = {}
const openAttendanceOffer = 'open-attendance-offer'
const cancelAttendanceOffer = 'cancel-attendance-offer'
const answerAttendanceOffer = 'answer-attendance-offer'
const answerAttendanceOfferText = 'answer-attendance-offer-text'

export default {
  mounted () {
    window.addEventListener('message', this.onAnswer)
    window.ipcRenderer.on(openAttendanceOffer, this.openAttendanceOffer)
    window.ipcRenderer.on(cancelAttendanceOffer, ({ id }) => this.closeAttendanceOffer(id))
  },

  beforeDestroy () {
    window.removeEventListener('message', this.onAnswer)
    window.ipcRenderer.off(openAttendanceOffer, this.openAttendanceOffer)
    window.ipcRenderer.off(cancelAttendanceOffer, ({ id }) => this.closeAttendanceOffer(id))
  },

  methods: {
    closeAttendanceOffer (attendanceId) {
      if (!popups[attendanceId]) return

      popups[attendanceId].close()
      delete popups[attendanceId]
      delete attendances[attendanceId]
    },

    onAnswer (event) {
      if (event.origin !== window.location.origin) return

      const { attendance, accepted } = event.data

      if (!attendance) return

      if (popups[attendance.id]) popups[attendance.id].close()
      delete popups[attendance.id]
      delete attendances[attendance.id]

      const answerChannel = attendance.channel === 'VOICE' ? answerAttendanceOffer : answerAttendanceOfferText
      window.ipcRenderer.send(answerChannel, null, { ...attendance, accepted })
    },

    openAttendanceOffer (attendance) {
      const width = 320
      const height = 125
      const left = window.screen.width - width
      const top = window.screen.height - height

      sessionStorage.setItem(`attendance-${attendance.id}`, JSON.stringify(attendance))

      const popupWindow = window.open('', 'offerWindow', `width=${width},height=${height},left=${left},top=${top},toolbar=no,location=no,status=no,menubar=no,scrollbars=no,resizable=no`)
      if ([null, undefined].includes(popupWindow?.closed)) return alert('Popup bloqueado! Por favor, permita pop-ups para este site.')
      popupWindow.document.write(newOfferContent(attendance.id))

      popups[attendance.id] = popupWindow
      attendances[attendance.id] = attendance
    }
  }
}

const newOfferContent = (attendanceId) => {
  return `
<html>
  <head>
    <style>
      body {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        margin: 0;
      }
      .button-container {
        position: fixed;
        bottom: 10px;
        right: 10px;
      }
      button {
        margin: 5px;
      }
    </style>
  </head>

  <body>
    <iframe src="/#/attendanceOffer/${attendanceId}" style="width: 100%; height: 100%; border: none;"></iframe>
  </body>
</html>
`
}

</script>
